// extracted by mini-css-extract-plugin
module.exports = {"container":"Statute_container__EnoHS","title":"Statute_title__2mK5h","content":"Statute_content__1Zqub"};